// @ts-ignore
import React, { lazy } from 'react';
const ComponentCentralBrandSelect = lazy(() => import('./components/componentCentralBrandSelect'));
const ComponentExperimentalPapi = lazy(() => import('./components/componentExperimentalPapi'));
const ComponentForcedLanguage = lazy(() => import('./components/componentForcedLanguage'));
const ComponentShowToast = lazy(() => import('./components/componentShowToast'));
const ComponentGooseAccordion = lazy(() => import('./components/componentGooseAccordion'));
const ComponentTable = lazy(() => import('./components/componentTable'));
const ComponentTabs = lazy(() => import('./components/componentTabs'));
const ComponentContextualNotification = lazy(() => import('./components/contextualNotification'));
const ComponentDownloadServiceStage = lazy(() => import('./components/downloadServiceStage'));
const ComponentErrorPage = lazy(() => import('./components/errorPage'));
const ComponentImageCarousel = lazy(() => import('./components/imageCarousel'));
const ComponentRoleWrapper = lazy(() => import('./components/roleWrapper'));
const ComponentServiceBenefits = lazy(() => import('./components/serviceBenefits'));
const ComponentServicePromoCard = lazy(() => import('./components/servicePromoCard'));
const ComponentStageKeyFunctions = lazy(() => import('./components/componentStageKeyFunctions'));
const ComponentStageWelcomeCard = lazy(() => import('./components/componentStageWelcomeCard'));
const ComponentWelcome = lazy(() => import('./components/welcome'));
const ComponentVerticalListStage = lazy(() => import('./components/componentVerticalListStage'));
const ComponentGooseColumnLayout = lazy(() => import('./components/componentGooseColumnLayout'));
const ComponentDiscontinued = lazy(() => import('./components/discontinued'));
const ComponentCompaniesAndServicesAccessNotification = lazy(() => import('./components/componentCompaniesAndServicesAccessNotification'));

export const customComponents = new Map();
customComponents.set('componentForcedLanguage', ComponentForcedLanguage);
customComponents.set('componentShowToast', ComponentShowToast);
customComponents.set('componentRoleWrapper', ComponentRoleWrapper);

// Overrides Service Benefits in dodo, again: smaller footprint and aligned with Fred on responsiveness
customComponents.set('componentGooseServiceBenefits', ComponentServiceBenefits);

// Overrides Error Page in dodo to provide more functionality
customComponents.set('componentErrorPage', ComponentErrorPage);

customComponents.set('componentServicePromoCard', ComponentServicePromoCard);
customComponents.set('componentContextualNotification', ComponentContextualNotification);

customComponents.set('componentImageCarousel', ComponentImageCarousel);

customComponents.set('componentCentralBrandSelect', ComponentCentralBrandSelect);

customComponents.set('componentExperimentalPapi', ComponentExperimentalPapi);

customComponents.set('componentTable', ComponentTable);

customComponents.set('componentTabs', ComponentTabs);

customComponents.set('componentGooseAccordion', ComponentGooseAccordion);

customComponents.set('componentDownloadStage', ComponentDownloadServiceStage);

customComponents.set('componentWelcome', ComponentWelcome);

customComponents.set('componentStageKeyFunctions', ComponentStageKeyFunctions);

customComponents.set('componentStageWelcomeCard', ComponentStageWelcomeCard);

customComponents.set('componentVerticalListStage', ComponentVerticalListStage);

customComponents.set('componentGooseColumnLayout', ComponentGooseColumnLayout);

customComponents.set('componentDiscontinued', ComponentDiscontinued);

customComponents.set('componentCompaniesAndServicesAccessNotification', ComponentCompaniesAndServicesAccessNotification);
